import { generatePagerProps } from '@fukuri-admins/utils/common/generatePagerProps';
import { useContractPlanList } from './hooks';
import { convertToPresentationProps } from './logics';
import { ContractPlanListPresentation } from './presentations';
import { ContractPlanListEmptyPresentation } from './presentations/empty';

/**
 * 契約プラン一覧 Container
 *
 * - 状態管理・アクションは useContractPlanList に委譲する
 * - API 型 → Presentation 型の変換は convertToPresentationProps に委譲する
 * - 無効プランの除外・isEmpty 判定は convertToPresentationProps が担う
 *
 * NOTE: 親コンポーネント（Screen）で Suspense にラップすること
 */
export const ContractPlanList: React.FC = () => {
  const {
    state: { data, currentPage, totalPage, totalCount, searchValue, isFiltered },
    actions: {
      handlePageChange,
      handleRowClick,
      handleSearchChange,
      handleSearch,
      handleSearchClear,
    },
  } = useContractPlanList();

  const { rows, isEmpty } = convertToPresentationProps({ data });

  const pagerProps = generatePagerProps({
    currentPage,
    totalPage,
    totalCount,
    rows,
    onPageChange: handlePageChange,
  });

  return isEmpty && !isFiltered ? (
    <ContractPlanListEmptyPresentation />
  ) : (
    <ContractPlanListPresentation
      rows={rows}
      pagerProps={pagerProps}
      onRowClick={handleRowClick}
      searchValue={searchValue}
      onSearchChange={handleSearchChange}
      onSearch={handleSearch}
      onSearchClear={handleSearchClear}
    />
  );
};
